import { createContext, useContext } from "react";
import type { DtoolsDisplaySettings } from "@shared/dtoolsDisplaySettings";

export type DtoolsProposalDisplayContextValue = DtoolsDisplaySettings & {
  audience?: "customer" | "staff";
  /** Staff sandbox: message when Cleo description/hover is missing. */
  cleoDescriptionPendingMessage?: string;
  /** Full-viewport cover (Link A + Link B) — offset sticky nav below fixed logo. */
  fullViewportCover?: boolean;
  /** Staff Link A only: show the discreet pre-markup price cue. */
  showInternalMarkupBasePrices?: boolean;
};

const defaultSettings: DtoolsProposalDisplayContextValue = {};

export const DtoolsProposalDisplayContext = createContext<DtoolsProposalDisplayContextValue>(defaultSettings);

export function useDtoolsProposalDisplay(): DtoolsProposalDisplayContextValue {
  return useContext(DtoolsProposalDisplayContext);
}
